var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E9FAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.0003 45.3334C39.3641 45.3334 45.3337 39.3638 45.3337 32C45.3337 24.6362 39.3641 18.6667 32.0003 18.6667C24.6365 18.6667 18.667 24.6362 18.667 32C18.667 39.3638 24.6365 45.3334 32.0003 45.3334Z",
    fill: "#549B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1069 36.7733C29.8402 36.7733 29.5869 36.6667 29.4002 36.48L25.6269 32.7067C25.2402 32.32 25.2402 31.68 25.6269 31.2933C26.0136 30.9067 26.6536 30.9067 27.0402 31.2933L30.1069 34.36L36.9602 27.5067C37.3469 27.12 37.9869 27.12 38.3736 27.5067C38.7602 27.8933 38.7602 28.5333 38.3736 28.92L30.8136 36.48C30.6269 36.6667 30.3736 36.7733 30.1069 36.7733Z",
    fill: "#549B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDone);
export default __webpack_public_path__ + "static/media/check-done.4f63af9022f11f5ac820463597d54647.svg";
export { ForwardRef as ReactComponent };